import React from 'react';
import classnames from 'classnames';
import { TwitterButton } from '../../../social-buttons/twitter';
import { YoutubeButton } from '../../../social-buttons/youtube';
import { FacebookButton } from '../../../social-buttons/facebook';
import styles from '../../card.scss';
export class SocialCardContent extends React.Component {
  renderThumbnail() {
    const {
      cardData
    } = this.props;
    const {
      thumbnailUrl
    } = cardData;
    if (!thumbnailUrl) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles.thumbnail
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.image,
      style: {
        backgroundImage: `url(${thumbnailUrl})`
      }
    }));
  }
  renderText() {
    const {
      cardData
    } = this.props;
    const {
      text
    } = cardData;
    return /*#__PURE__*/React.createElement("div", {
      className: styles.text
    }, /*#__PURE__*/React.createElement("div", {
      className: styles['text-content'],
      "data-hook": "action-card-title"
    }, text));
  }
  renderCta() {
    const {
      cardData
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(styles.social, styles[cardData.network]),
      "data-hook": "action-card-action-text"
    }, this.renderSocialButton());
  }
  renderSocialButton() {
    const {
      cardData,
      labels,
      isAccessible
    } = this.props;
    const {
      facebookButtonTitle,
      youtubeButtonTitle,
      twitterButtonTitle
    } = labels;
    switch (cardData.network) {
      case 'twitter':
        return /*#__PURE__*/React.createElement(TwitterButton, {
          isAccessible: isAccessible,
          twitterButtonTitle: twitterButtonTitle,
          cardData: cardData
        });
      case 'youtube':
        return /*#__PURE__*/React.createElement(YoutubeButton, {
          isAccessible: isAccessible,
          youtubeButtonTitle: youtubeButtonTitle,
          cardData: cardData
        });
      case 'facebook':
        return /*#__PURE__*/React.createElement(FacebookButton, {
          isAccessible: isAccessible,
          facebookButtonTitle: facebookButtonTitle,
          cardData: cardData
        });
      default:
        return null;
    }
  }
  render() {
    const {
      className,
      isAriaHidden
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      "aria-hidden": isAriaHidden
    }, this.renderThumbnail(), /*#__PURE__*/React.createElement("div", {
      className: styles.container
    }, this.renderText(), this.renderCta()));
  }
}
//# sourceMappingURL=card-content.js.map